/* @flow */
import cx from 'classnames';
import Avatar from 'components/Avatar.jsx';
import GroupMembership from 'entities/GroupMembership';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import RelationshipModal from 'user/components/RelationshipModal.jsx';
import Text from 'components/Text.jsx';
import UserLink from 'users/components/UserLink.jsx';
import './styles/GroupMemberListItem.scss';

class GroupMembershipListItem extends React.Component {
  static propTypes = {
    classMember: React.PropTypes.instanceOf(GroupMembership).isRequired,
    highlight: React.PropTypes.bool,
    owner: React.PropTypes.bool,
  };

  render() {
    const name = this.props.classMember.getName();
    const member = this.props.classMember;
    const user = this.props.classMember.getUser();

    return (
      <li
        className={cx({
          GroupMemberListItem: true,
          'GroupMemberListItem-highlight': this.props.highlight,
        }, this.props.className)}>
        <UserLink
          className="GroupMemberListItem-link"
          userId={member.getUserId()}
          placement="left"
          alignment="top">
          <ModalTrigger modal={<RelationshipModal userId={member.getUserId()} />}>
            <span className="GroupMemberListItem-link-trigger">
              <Avatar
                className="GroupMemberListItem-droplet"
                size="medium"
                colorHex={user.getColor()}
                text={user.getInitials()}
              />
              <Text className="GroupMemberListItem-name">{name}</Text>
            </span>
          </ModalTrigger>
        </UserLink>
      </li>
    );
  }
}

export default GroupMembershipListItem;



// WEBPACK FOOTER //
// ./src/groups/components/GroupMemberListItem.jsx